import { FormattedAxnAttributeLabel } from "@idw-types/data/reference-data/axn";

export enum AttributeLabelsActionTypes {
    // Attribute Labels
    SET_ATTRIBUTE_LABELS_LOADING = "SET_ATTRIBUTE_LABELS_LOADING",
    SET_ATTRIBUTE_LABELS = "SET_ATTRIBUTE_LABELS",
    ADD_ATTRIBUTE_LABEL = "ADD_ATTRIBUTE_LABEL",
}

// Attribute Labels
type SetAttributeLabelsLoadingAction = {
    type: AttributeLabelsActionTypes.SET_ATTRIBUTE_LABELS_LOADING,
    payload: { isLoading: boolean; }
};

export const setAttributeLabelsLoading = (isLoading: boolean): SetAttributeLabelsLoadingAction => ({
    type: AttributeLabelsActionTypes.SET_ATTRIBUTE_LABELS_LOADING,
    payload: { isLoading }
});

type SetAttributeLabelsAction = {
    type: AttributeLabelsActionTypes.SET_ATTRIBUTE_LABELS,
    payload: { axnAttributeLabels: Array<FormattedAxnAttributeLabel>; }
}

export const setAttributeLabels = (axnAttributeLabels: Array<FormattedAxnAttributeLabel>): SetAttributeLabelsAction => ({
    type: AttributeLabelsActionTypes.SET_ATTRIBUTE_LABELS,
    payload: { axnAttributeLabels }
});

type AddAttributeLabelAction = {
    type: AttributeLabelsActionTypes.ADD_ATTRIBUTE_LABEL;
    payload: { attributeLabel: FormattedAxnAttributeLabel };
};

export const addAttributeLabel = (attributeLabel: FormattedAxnAttributeLabel): AddAttributeLabelAction => ({
    type: AttributeLabelsActionTypes.ADD_ATTRIBUTE_LABEL,
    payload: { attributeLabel }
});

export type AttributeLabelsActions =
    // Attribute Labels
    SetAttributeLabelsLoadingAction |
    SetAttributeLabelsAction |
    AddAttributeLabelAction